<div class="add-beneficiary-container container">
    <div class="add-beneficiary-header pt-4">
        <h5 class="app-module-title">
            Agrega beneficiario
        </h5>
        <p class="x-small-label text-uppercase spaced-label">con ID de tarjeta</p>
        <!--        <div class="description">-->
        <!--            <div class="small-label">-->
        <!--                Número de empresa seguido de un guión con el número de empleado.-->
        <!--            </div>-->
        <!--            <span></span>-->
        <!--            <div matTooltip="click para obtener ayuda" (click)="showHelpFn()">-->
        <!--                <span class="material-symbols-rounded">help_outline</span>-->
        <!--            </div>-->
        <!--        </div>-->
    </div>
    <div class="add-beneficiary-content">
        <form [formGroup]="cardSearchForm" class="form-container">
            <mat-form-field class="w-100"
                            floatLabel="never">
                <span matPrefix class="material-symbols-rounded">credit_card</span>
                <input
                    autofocus
                    upperCase
                    id="cuenta_r"
                    #cardSearchInput
                    type="search"
                    matInput
                    placeholder="Número de tarjeta que vas a registrar"
                    formControlName="cardSearchInput"
                    (keydown.enter)="inputBeneficiariesActions()"
                />
                <!--                <button matSuffix-->
                <!--                        mat-button-->
                <!--                        mat-icon-button-->
                <!--                        color="primary"-->
                <!--                        type="button"-->
                <!--                        id="search-button"-->
                <!--                        (click)="localizeCard()">-->
                <!--                    <span class="material-symbols-rounded" matTooltip="Buscar">{{ inputObject.icon }}</span>-->
                <!--                </button>-->
            </mat-form-field>
            <div class="d-flex align-items-center gap-3 pt-3"
                 *ngIf="cardSearchForm.get(['cardSearchInput']).hasError('required')
                        && cardSearchForm.get('cardSearchInput').touched">
                <img src="../../../assets/img/error-circle-100.svg"
                     width="32"
                     height="32"
                     alt="Account Error">
                <p class="text-danger m-0">Por favor ingresa una tarjeta valida.</p>
            </div>
            <div class="d-flex align-items-center gap-3 pt-3"
                 *ngIf="cardSearchForm.get(['cardSearchInput']).hasError('pattern')">
                <img src="../../../assets/img/error-circle-100.svg"
                     width="32"
                     height="32"
                     alt="Account Error">
                <p class="text-danger m-0">
                    Verifica que tu número de tarjeta sea correcto,
                    <strong>consulta la ayuda.</strong>
                </p>
            </div>
        </form>
    </div>
    <div class="add-beneficiary-bottom">
        <button mat-flat-button
                class="role-action-btn w-100"
                (click)="inputBeneficiariesActions()">
            Agregar
        </button>
    </div>
</div>

<ng-template #personalDataDialog>
    <p class="x-small-text text-uppercase spaced-label">Información de Beneficiario</p>
    <p class="x-small-label">Por favor ingresa tu nombre para continuar</p>
    <form class="py-3" [formGroup]="bPersonalData">
        <div style="display:flex; flex-direction: column;">
            <!--            <p style="font-weight: 500" *ngIf="sp100Out[0].req_nombre === 3">-->
            <!--                {{ sp100Out[0].nombre }} {{ sp100Out[0].apellido_p }}-->
            <!--                {{ sp100Out[0].apellido_m }}-->
            <!--            </p>-->
            <!-- {{ bPersonalData.get('nombre').hasError('pattern') }} -->
            <p class="x-small-label text-uppercase spaced-label my-3">Nombre</p>
            <mat-form-field floatLabel="never">
                <!--                <mat-hint>-->
                <!--                    Escribe el nombre del beneficiario, unicamente letras mayor-->
                <!--                    a 2 letras, el campo es obligatorio-->
                <!--                </mat-hint>-->
                <input
                    upperCase
                    autofocus
                    #inputName
                    type="text"
                    matInput
                    formControlName="nombre"
                    placeholder="Nombre(s)"
                />
                <mat-error *ngIf="bPersonalData.get('nombre').hasError('pattern')">
                    Escribe unicamente letras.
                </mat-error>
                <mat-error *ngIf="bPersonalData.get('nombre').hasError('required')">
                    Se requiere el nombre.
                </mat-error>
                <mat-error *ngIf="bPersonalData.get('nombre').hasError('minlength')">
                    Debe de ser mayor a 2 letras.
                </mat-error>
            </mat-form-field>
            <p class="x-small-label text-uppercase spaced-label my-3">Apellidos</p>
            <mat-form-field floatLabel="never">
                <!--                <mat-hint>-->
                <!--                    Escribe el apellido paterno del beneficiario, unicamente-->
                <!--                    letras mayor a 2 letras, el campo es obligatorio-->
                <!--                </mat-hint>-->
                <input
                    upperCase
                    type="text"
                    matInput
                    formControlName="apellido_p"
                    placeholder="Apellidos"
                />
                <mat-error *ngIf="bPersonalData.get('apellido_p').hasError('pattern')">
                    Escribe unicamente letras.
                </mat-error>
                <mat-error *ngIf="bPersonalData.get('apellido_p').hasError('required')">
                    Se requieren apellidos.
                </mat-error>
                <mat-error
                    *ngIf="
                        bPersonalData.get('apellido_p').hasError('minlength')
                    ">
                    Debe de ser mayor a 2 letras.
                </mat-error>
            </mat-form-field>
            <!--            <p class="x-small-label text-uppercase spaced-label">Apellido paterno</p>-->
            <!--            <mat-form-field floatLabel="never">-->
            <!--                <input-->
            <!--                    upperCase-->
            <!--                    type="text"-->
            <!--                    matInput-->
            <!--                    formControlName="apellido_m"-->
            <!--                    placeholder="Apellido Materno"-->
            <!--                />-->
            <!--&lt;!&ndash;                <mat-hint>&ndash;&gt;-->
            <!--&lt;!&ndash;                    Escribe el apellido materno del beneficiario, unicamente&ndash;&gt;-->
            <!--&lt;!&ndash;                    letras mayor a 2 letras, el campo es obligatorio.&ndash;&gt;-->
            <!--&lt;!&ndash;                </mat-hint>&ndash;&gt;-->
            <!--                <mat-error *ngIf="bPersonalData.get('apellido_m').hasError('pattern')">-->
            <!--                    Escribe unicamente letras.-->
            <!--                </mat-error>-->
            <!--                <mat-error *ngIf="bPersonalData.get('apellido_m').hasError('required')">-->
            <!--                    Se requiere el apellido materno.-->
            <!--                </mat-error>-->
            <!--                <mat-error-->
            <!--                    *ngIf="-->
            <!--                        bPersonalData.get('apellido_m').hasError('minlength')-->
            <!--                    ">-->
            <!--                    Debe de ser mayor a 2 letras.-->
            <!--                </mat-error>-->
            <!--            </mat-form-field>-->
            <!--            <mat-form-field-->
            <!--                *ngIf="-->
            <!--                    sp100Out[0].req_telefono !== 0 &&-->
            <!--                    sp100Out[0].req_telefono !== 3-->
            <!--                "-->
            <!--                floatLabel="never"-->
            <!--            >-->
            <!--                <mat-hint align="end"-->
            <!--                >{{-->
            <!--                    bPersonalData.get('telefono').value.length || 0-->
            <!--                    }}/10</mat-hint-->
            <!--                >-->
            <!--                <mat-hint>-->
            <!--                    Número de 10 digitos. ejemplo: 6643554466-->
            <!--                </mat-hint>-->

            <!--                <input-->
            <!--                    type="text"-->
            <!--                    matInput-->
            <!--                    formControlName="telefono"-->
            <!--                    placeholder="teléfono"-->
            <!--                />-->
            <!--            </mat-form-field>-->
        </div>
    </form>
    <hr class="app-module-subtitle"/>
    <div class="multiple-separation-bottom-actions">
        <button mat-flat-button
                class="bg-transparent accent-color w-100"
                (click)="insertBeneficiaries()">
            Guardar
        </button>
        <hr class="app-module-subtitle"/>
        <button mat-flat-button
                class="bg-transparent accent-red-color w-100"
                (click)="dismiss()">
            Cancelar
        </button>
    </div>
</ng-template>

<ng-template #existingCard>
    <div class="unable-to-deliver-content p-3">
        <div>
            <p class="medium-text fw-bold m-0 pb-3">
                {{ cfMessage }}
            </p>
        </div>
        <div>
            <p class="small-label pb-3">
                Intenta agregar otra tarjeta o verificar si el numero de tarjeta ingresado es correcto.
            </p>
        </div>
        <div>
            <button mat-flat-button
                    class="role-action-btn w-100"
                    (click)="dismiss()">
                Aceptar
            </button>
        </div>
    </div>
</ng-template>
<ng-template #invalidCard>
    <div class="unable-to-deliver-content p-3">
        <div>
            <p class="medium-text fw-bold m-0 pb-3">
                {{ badReqMessage }}
            </p>
        </div>
        <div>
            <p class="small-label pb-3">
                Esta tarjeta no es elegible para el programa de beneficiarios.
            </p>
        </div>
        <div>
            <button mat-flat-button
                    class="role-action-btn w-100"
                    (click)="dismiss()">
                Aceptar
            </button>
        </div>
    </div>
</ng-template>
<ng-template #maximumReached>
    <div class="unable-to-deliver-content p-3">
        <div>
            <p class="medium-text fw-bold m-0 pb-3">
                {{ unEntityMessage }}
            </p>
        </div>
        <div>
            <p class="small-label pb-3">
                Se permite un maximo de 3 beneficiarios por cuenta.
            </p>
        </div>
        <div>
            <button mat-flat-button
                    class="role-action-btn w-100"
                    (click)="dismiss()">
                Aceptar
            </button>
        </div>
    </div>
</ng-template>